<template>
	<div class="card">
		<div class="card-header pb-0" >
			<h6>Delivery Order</h6>
		</div>
		<div class="card-body px-0 pt-0 pb-2">
			<div class="table-responsive p-0">
				<table class="table align-items-center mb-0">
					<thead>
						<tr>
							<th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">No DO</th>
							<th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">No SO </th>
							<th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Customer </th>
							<th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Request Date</th>
							<th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Target Date</th>
							<th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Items </th>
							<th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">WH </th>
							<th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Remaining</th>
						</tr>
					</thead>
					<tbody>
						<tr v-if="countData <= 0">
							<td>
								<div class="d-flex px-2 py-1">
									<div class="d-flex flex-column justify-content-center">
										<h6 class="mb-0 text-sm">NO DATA</h6>
									</div>
								</div>
							</td>
						</tr>
						<tr v-else v-for="item in dataDO" :key="item.no_do">
							<!--
							<td>
								<div class="d-flex px-2 py-1">
									<div class="d-flex flex-column justify-content-center">
										<h6 class="mb-0 text-sm">{{ item.no_do }}</h6>
									</div>
								</div>
							</td>
							-->
							<td>
								<p class="text-xs font-weight-bold mb-0">{{ item.no_do }}</p>
							</td>
							<td>
								<p class="text-xs font-weight-bold mb-0">{{ item.no_so }}</p>
							</td>
							<td>
								<p class="text-xs font-weight-bold mb-0">{{ item.customer }}</p>
							</td>
							<!--
							<td class="align-middle text-center text-sm">
								<span class="badge badge-sm bg-gradient-success">Success</span>
							</td>
							<td class="align-middle text-center text-sm">
								<span class="badge badge-sm bg-gradient-warning">Warning</span>
							</td>
							<td class="align-middle text-center text-sm">
								<span class="badge badge-sm bg-gradient-danger">Danger</span>
							</td>
							-->
							<td class="align-middle text-center">
								<span class="text-secondary text-xs font-weight-bold">{{getFormattedDate(item.create_date)}}</span>
							</td>
							<td class="align-middle text-center">
								<span class="text-secondary text-xs font-weight-bold">{{getFormattedDate(item.target_date)}}</span>
							</td>
							<td>
								<p class="text-xs font-weight-bold mb-0">{{ item.count_do }}</p>
							</td>
							<td>
								<p class="text-xs font-weight-bold mb-0">{{ item.warehouse }}</p>
							</td>
							<td class="align-middle text-center">
								<!-- If day 0 or undefined and hour 0 or undefined and minute 0 or undefined and second 0 or undefined -->
								<div v-if="item.remaining.days === undefined && item.remaining.hours === undefined && item.remaining.minutes === undefined && item.remaining.seconds === undefined">
									<span class="text-dark text-xs font-weight-bold 
										badge badge-sm bg-gradient-danger" 
									>
										{{getRemainingDate(item.remaining)}}
									</span>
								</div>

								<!-- If day 0 or undefined and hour 0 or undefined and minute 0 or undefined -->
								<div v-else-if="item.remaining.days === undefined && item.remaining.hours === undefined && item.remaining.minutes === undefined">
									<span class="text-dark text-xs font-weight-bold 
										badge badge-sm bg-gradient-danger" 
									>
										{{getRemainingDate(item.remaining)}}
									</span>
								</div>

								<!-- If day 0 or undefined and hour 0 or undefined -->
								<div v-else-if="item.remaining.days === undefined && item.remaining.hours === undefined">
									<span class="text-dark text-xs font-weight-bold 
										badge badge-sm bg-gradient-danger" 
									>
										{{getRemainingDate(item.remaining)}}
									</span>
								</div>
								
								<!-- If day 0 or undefined -->
								<div v-else-if="item.remaining.days === undefined">
									<span class="text-dark text-xs font-weight-bold 
										badge badge-sm bg-gradient-warning" 
									>
										{{getRemainingDate(item.remaining)}}
									</span>
								</div>

								<!-- If day 1 or more -->
								<div v-else>
									<div v-if="item.remaining.days <= 0">
										<span class="text-dark text-xs font-weight-bold 
											badge badge-sm bg-gradient-danger" 
										>
											{{getRemainingDate(item.remaining)}}
										</span>
									</div>
									<div v-else>
										<span class="text-dark text-xs font-weight-bold 
											badge badge-sm bg-gradient-success" 
										>
											{{getRemainingDate(item.remaining)}}
										</span>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	import formMixin from "../../../../mixins/form-mixin.js";
	import showSwal from "../../../../mixins/showSwal.js";
	import axios from 'axios';
	import moment from 'moment';

	const API_URL = process.env.VUE_APP_API_BASE_URL;
	var URL ="";

	export default {
		name: "list-do",
		data() {
			return {
				 pagination: {
					enabled: true,
					perPage: 3,
					setCurrentPage: 1
				},
				showMenu: false,
				dataDO: [],
				dataDODetail: []
			};
		},
		
		mixins: [formMixin, showSwal],
		computed: {
			
		},
		mounted () {
			this.fetchData();
			
			this.interval = setInterval(function () {
                this.fetchData();
            }.bind(this), 1000);
			
		},
		methods: {
			fetchData() {
				URL = API_URL + '/delivery_order/list'
				axios.get(URL,
				{
					headers: {
						'Access-Control-Allow-Origin': '*',
                		'Content-type': 'application/json;charset=UTF-8',
						'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
					},
				})
			.	then(response => {
					this.title = response.data.title;
					this.dataDO = response.data;
					this.countData = this.dataDO.length
				});
			},	
			getFormattedDate(date) {
				return moment(date).format("YYYY-MM-DD hh:mm")
			},
			getRemainingDate(data) {
				var days = data.days
				var hours = data.hours
				var minutes = data.minutes
				var seconds = data.seconds
				if (days === undefined) {
					days = 0;
				}
				if (hours === undefined) {
					hours = 0;
				}
				if (minutes === undefined) {
					minutes = 0;
				}
				if (seconds === undefined) {
					seconds = 0;
				}
				var getDetailRemaining = days + ' days' + ' ' + hours + ' hours' + ' ' + minutes + ' minutes' + ' ' + seconds + ' seconds'
				return getDetailRemaining
			},
		}
	};
</script>
